<template>
  <div>
    <Head :title="`${form.first_name} ${form.last_name}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link v-if="auth.user.role_id == 1" class="text-orange-400 hover:text-orange-600" href="/usuarios">Usuarios</Link>
        <span class="text-orange-400 font-medium">/</span>
        {{ form.first_name }} {{ form.last_name }}
      </h1>
      <img v-if="user.photo" class="block ml-4 w-8 h-8 rounded-full" :src="user.photo" />
    </div>
    <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore"> This user has been deleted. </trashed-message>
    <div class="lg:flex">
      <div class="p-4 bg-white rounded-md shadow max-w-3xl">
        <form @submit.prevent="update">
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nombre" />
            <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Apellidos" />
            <label v-if="auth.user.role_id == 1" class="pb-2">Oficinas:</label>
            <VueMultiselect
              v-if="auth.user.role_id == 1"
              v-model="form.user_organizations"
              class="pb-8 mr-6"
              :options="organizations"
              :multiple="true"
              :close-on-select="true"
              placeholder="Buscar oficina"
              label="name"
              track-by="name"
            />
            <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" />
            <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/2" type="password" autocomplete="new-password" label="Contraseña" />
            <select-input v-if="auth.user.role_id == 1" v-model="form.role_id" :error="form.errors.role_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Rol">
              <option :value="null" />
              <option v-for="role in roles" :key="role.id" :value="role.id">
                {{ role.name }}
              </option>
            </select-input>
            <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Imagen" />
          </div>
          <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
            <button v-if="!user.deleted_at && auth.user.role_id == 1" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Eliminar Usuario</button>
            <loading-button :loading="form.processing" class="btn-orange ml-auto" type="submit">Actualizar</loading-button>
          </div>
        </form>
      </div>
      <div v-if="user.organization && auth.user.role_id == 1" class="w-full p-4 pt-0">
        <div class="px-8 py-4 shadow rounded-t bg-gray-50 border-t border-gray-100">
          <h2 class="text-2xl font-bold">Oficina asociada</h2>
        </div>
        <div class="bg-white rounded-b shadow hover:bg-gray-100 font-bold overflow-x-auto">
          <Link class="flex items-center px-6 focus:text-orange-500" :href="`/oficinas/${user.organization.id}/editar`">
            <p class="pb-4 pt-6 px-6">{{ user.organization.name }}</p>
          </Link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import VueMultiselect from 'vue-multiselect'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    VueMultiselect,
  },
  layout: Layout,
  props: {
    user: Object,
    organizations: Array,
    roles: Array,
    auth: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        role_id: this.user.role_id,
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        organization_id: this.user.organization_id,
        user_organizations: this.user.organizations,
        email: this.user.email,
        password: '',
        owner: this.user.owner,
        photo: null,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/usuarios/${this.user.id}`, {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Estas seguro de eliminar este usuario?')) {
        this.$inertia.delete(`/usuarios/${this.user.id}`)
      }
    },
    restore() {
      if (confirm('Estas seguro de restaurar este usuario?')) {
        this.$inertia.put(`/usuarios/${this.user.id}/restaurar`)
      }
    },
  },
}
</script>
